import { useCallback } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

export function useVideoCarouselAnalytics() {
    const { createAnalyticsEvent } = useAnalyticsEvents();

    const firePlayPauseClicked = useCallback(
        (label: "play" | "pause") => {
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "playPause",
                source: "videoCarousel",
                attributes: { label }
            }).fire();
        },
        [createAnalyticsEvent]
    );

    const fireTeamSelected = useCallback(
        (team: string) => {
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "teamSelector",
                source: "videoCarousel",
                attributes: { team }
            }).fire();
        },
        [createAnalyticsEvent]
    );

    return { firePlayPauseClicked, fireTeamSelected };
}
